import { diunaImperiumChapters } from './content';
export const diunaImperiumQuickReference = diunaImperiumChapters.find((chapter) => chapter.title.toLocaleUpperCase('pl').includes('QUICK REFERENCE'));
